export const pad2 = (n: number) => ('0' + n).slice(-2);
